import { FC, useState } from 'react';
import { Button, Icon, Modal, ModalProps } from 'semantic-ui-react';

interface Props extends ModalProps {
    message: string | string[];
    onClose: () => void;
    header?: string
}


const MessageWindow: FC<Props> = (props) => {
    const { message, onClose, header, ...modalProps } = props;

    return (
        <Modal
            size='mini'
            open={true}
            {...modalProps}
            onClose={onClose}
        >
            <Modal.Header>{header}</Modal.Header>
            <Modal.Content scrolling>
                <Modal.Description>
                    {Array.isArray(message) ? message.map(m => <p>{m}</p>) : message}
                </Modal.Description>
            </Modal.Content>
            <Modal.Actions>
                <Button circular onClick={onClose}>
                    Close
                </Button>
            </Modal.Actions>
        </Modal>
  )
}

export default MessageWindow;